import { render, staticRenderFns } from "./dashboard-laboratin.html?vue&type=template&id=fd9dea1c&scoped=true&external"
import script from "./dashboard-laboratin.js?vue&type=script&lang=js&external"
export * from "./dashboard-laboratin.js?vue&type=script&lang=js&external"
import style0 from "./dashboard-laboratin.scss?vue&type=style&index=0&id=fd9dea1c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9dea1c",
  null
  
)

export default component.exports